module.exports = {
    // 学生 
    STUDENT:{
        RETRIEVE: [0, 1],// 查看
        EDIT: [0, 2]// 编辑
    },
    // 老师 
    TEACHER:{
        RETRIEVE: [1, 1],// 查看
        EDIT: [1, 2]// 编辑
    },
    // 角色 
    ROLE:{
        RETRIEVE: [2, 1],// 查看
        CREATE: [2, 2],// 创建
        UPDATE: [2, 4],// 修改
        DELETE: [2, 8]// 删除
    },
    // 院系 
    DEPT:{
        RETRIEVE: [3, 1],// 查看
        EDIT: [3, 2]// 编辑
    },
    // 专业 
    MAJOR:{
        RETRIEVE: [4, 1],// 查看
        CREATE: [4, 2],// 创建
        UPDATE: [4, 4],// 修改
        DELETE: [4, 8]// 删除
    },
    // 学期 
    SCHOOL_TERM:{
        RETRIEVE: [5, 1],// 查看
        CREATE: [5, 2],// 创建
        UPDATE: [5, 4],// 修改
        DELETE: [5, 8]// 删除
    },
    // 课程 
    COURSE:{
        RETRIEVE: [6, 1]// 查看
    },
    // 班课 
    CLAZZ_COURSE:{
        RETRIEVE: [7, 1]// 查看
    },
    // 教材 
    TEXTBOOK:{
        RETRIEVE: [8, 1],// 查看
        CREATE: [8, 2],// 创建
        UPDATE: [8, 4],// 修改
        DELETE: [8, 8],// 删除
        STAT: [8, 16],// 使用统计
        SUBMIT_REVIEW: [8, 32],// 提交审核
        WITHDRAW_REVIEW: [8, 64],// 撤回审核
        AUDIT: [8, 128],// 审核
        RELEASE: [8, 256]// 发布
    },
    // 兑换码 
    REDEEM_CODE:{
        RETRIEVE: [9, 1],// 查看
        CREATE: [9, 2],// 创建
        DOWNLOAD: [9, 4]// 下载
    },
    // 栏目 
    COLUMN:{
        RETRIEVE: [10, 1],// 查看
        CREATE: [10, 2],// 创建
        UPDATE: [10, 4],// 修改
        DELETE: [10, 8]// 删除
    },
    // 新闻资讯 
    NEWS:{
        RETRIEVE: [11, 1],// 查看
        CREATE: [11, 2],// 创建
        UPDATE: [11, 4],// 修改
        DELETE: [11, 8],// 删除
        PUBLISH: [11, 16]// 发布&#x2F;撤回
    },
    // 教材教务统计 
    TEXTBOOK_CXJW_STAT:{
        RETRIEVE: [12, 1],// 查看
        DOWNLOAD: [12, 2]// 下载
    },
    // 账户管理 
    ACCOUNT_MGT:{
        RETRIEVE: [13, 1],// 查看
        UPDATE: [13, 4]// 修改
    },
    // 题库 
    DRILL:{
        RETRIEVE: [14, 1],// 查看
        CREATE: [14, 2],// 创建
        UPDATE: [14, 4],// 修改
        DELETE: [14, 8]// 删除
    }
}